import React, { Component } from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import TinyMCE from 'react-tinymce';

export default class PreOpenMessageSection extends Component {
	render() {
		// TinyMCE resolves the path to tinymce.css in a relative way, so the context
		// needs to be setup for each component using it.  Ohhhh, TinyMCE....
		let tinyMCECssPathContext = '../../../';
		let tinyMCEConfig = {
			...Defaults.TINYMCE_CONFIG,
			toolbar_drawer: '',
			contextmenu: false
		};
		
		tinyMCEConfig.content_css = tinyMCEConfig.content_css.replace(':pathContext:', tinyMCECssPathContext);
		
		return (
			<section className='pre-open-message'>
				<label>
					Message before form opens
				</label>

				<TinyMCE
					content={this.props.message}
					config={tinyMCEConfig}
					onBlur={this.handleContentChange.bind(this, FormSettings.PRE_OPEN_MESSAGE)}
				/>

			</section>
		);
	}
	
	handleContentChange = (propertyName, evt) => {
		let rteContent = evt.target.getContent();
		this.props.updateCallback(propertyName, rteContent);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/pre-open-message.js